export const RTCBufferTypes = {
    BUFFER_INPUT_PUSH : 'BUFFER_INPUT_PUSH_RTC_BUFFER',
    BUFFER_INPUT_POP : 'BUFFER_INPUT_POP_RTC_BUFFER',
    BUFFER_OUTPUT_PUSH : 'BUFFER_OUTPUT_PUSH_RTC_BUFFER',
    BUFFER_OUTPUT_POP : 'BUFFER_OUTPUT_POP_RTC_BUFFER',
    RESET : 'RESET'
};